var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownCurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 215,
    viewBox: "0 0 132 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M132 209V209C109.613 209 89.9414 194.154 83.8017 172.626L46.2311 40.8896C40.3419 20.2401 21.4728 6.00001 2.48803e-06 6V6",
    stroke: "url(#paint0_linear_2853_20812)",
    strokeOpacity: 0.64,
    strokeWidth: 12
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2853_20812",
    x1: 132,
    y1: 209,
    x2: -55.0375,
    y2: 110.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C17400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C10097"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownCurve);
export default __webpack_public_path__ + "97120/static/media/down-curve.d43107e4021dea645db5c2a653f06851.svg";
export { ForwardRef as ReactComponent };